import React, { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { getRecommendations, searchArtist } from '../../store/reducers/searchReducer'
import { Card } from '../common/card/Card'
import { AppInput } from '../common/input/AppInput'
import styles from './Search.module.css'

export const Search = () => {
    const { recommendedArtists, artist, isFetching } = useSelector(state => state.search)
    const { register, handleSubmit, formState: { errors } } = useForm();

    const [didTrySearch, setDidTrySearch] = useState(!!artist)
    const dispatch = useDispatch()
    const [recommendationsErr, setRecommendationsErr] = useState()
    const [timersIds, setTimersIds] = useState()

    const loadRecommendations = useCallback(async () => {
        try {
            await dispatch(getRecommendations())
        } catch (e) {
            setRecommendationsErr(e.code)
        }
    }, [dispatch, getRecommendations])

    useEffect(() => {
        loadRecommendations()
    }, [loadRecommendations])

    const onSubmit = async (formData) => {
        clearTimeout(timersIds)
        let timerId = setTimeout(async () => {
            try {
                await dispatch(searchArtist(formData.search))
                setDidTrySearch(formData.search ? true : false)
            } catch (e) {
                alert(e.code)
            } finally {
                setDidTrySearch(formData.search ? true : false)

            }
        }, 500)
        setTimersIds(timerId)
    }

    return <div className={styles.search}>
        <form
            className={styles.search__form}
            onSubmit={(e) => e.preventDefault()}
            onChange={handleSubmit(onSubmit)}
        >
            <AppInput
                placeholder='search artists...'
                type='text'
                value={artist}
                register={register}
                field='search'
            />
        </form>
        {isFetching ? <div>FETCHING...</div> :
            <div className={styles.recs}>
                {(didTrySearch && artist) && <Card key={artist}>{artist}</Card>}
                {(didTrySearch && !artist) && <div>Can not find this stuff, bro(((</div>}
                {(!didTrySearch && !artist && recommendedArtists) && Object.keys(recommendedArtists).map(artist => {
                    return <Card 
                    src={recommendedArtists[artist][Object.keys(recommendedArtists[artist])[0]].art}
                    key={artist}>{artist}</Card>
                })}
            </div>
        }
        {recommendationsErr && <div>Cannot recommend you nothing...</div>}
    </div>
}